/**
 * Owner-facing projection of terminal / TUI bytes for Command transcript and logs.
 *
 * Reuses the #271 persistent-adapter sanitization contract
 * (`plainPersistentTerminalText` in brunel-node): strip SGR colour/style CSI,
 * turn cursor/erase CSI and OSC into line breaks, drop other controls. This is
 * a bounded text projection for reading — not a second terminal renderer and
 * not a change to the persistent PTY architecture.
 */

const ANSI_CSI = /\u001b\[[0-?]*[ -/]*[@-~]/g;
const ANSI_OSC = /\u001b\][^\u0007\u001b]*(?:\u0007|\u001b\\)/g;
const ANSI_SINGLE = /\u001b[@-_]/g;
const OTHER_CONTROLS = /[\u0000-\u0008\u000b\u000c\u000e-\u001a\u001c-\u001f\u007f]/g;

/** Printable text from a terminal chunk or run tail, without escape garbage. */
export function plainTerminalText(text: string): string {
  return text
    .replace(ANSI_OSC, '')
    .replace(ANSI_CSI, (escape) => (escape.endsWith('m') ? '' : '\n'))
    .replace(ANSI_SINGLE, '\n')
    .replace(/\r/g, '\n')
    .replace(OTHER_CONTROLS, '')
    .split('\n')
    .map((line) => line.replace(/[ \t]+/g, ' ').trimEnd())
    .filter((line, index, lines) => line !== '' || (index > 0 && lines[index - 1] !== ''))
    .join('\n')
    .trim();
}
